<template lang="pug">
.import-modal
  b-modal(id="importmodal", :title="title", size="sm", ok-variant="primary",  ref="importmodal", ok-only, cancel-title="Abbrechen", @ok="save()").modal-fullscreen2
    div.form-group(v-if="project")
        
        .d-flex.justify-content-between.align-items-center(v-show="!loading && !uploaded")
          div(v-show="!loading").w-100     
            dropzone-file-upload(:ref="'dz'", v-model="inputs.fileMultiple", multiple, :url="base_url + '/projects/' + project._id + '/detail_list'", :options="ulConfig", @complete="ulComplete($event, project)" @sending="loading=true")

        
        .d-flex.justify-content-between.align-items-center().w-100.h-100
          div(v-show="loading").w-100    
            i.fas.fa-spinner.fa-spin.text-primary.mt-2(
              style="font-size: 2rem"

            )
        
        .d-flex.justify-content-between.align-items-center(v-show="uploaded")
          div(v-show="uploaded").w-100    
            i.fas.fa-check.text-success.mt-2(
              style="font-size: 2rem"

            ) 
            | Anforderungsliste erfolgreich importiert
        
        .d-flex.justify-content-between.align-items-center(v-show="error")
          div(v-show="error").w-100    
            i.fas.fa-times.text-danger.mt-2(
              style="font-size: 2rem"

            ) 
            | Import nicht erfolgreich
        


              
</template>

<script>
// @ is an alias to /src


import Vue from 'vue'
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import { resolve } from 'path'

export default {

  name: 'importModal',
  props: [],
 
  data() {
      return {

        ulConfig: {maxFilesize: 500, acceptedFiles: 'application/vnd.ms-excel', withCredentials: true, previewsContainer: null, disablePreviews: false, dictDefaultMessage: 'Anforderungsliste hochladen'},
        selectedResult: 0,
        inputs: {fileMultiple: []},
        projectName: "",
        fileConfig: "{kks}_{class_name}_{dcc}",
        loading: false,
        uploaded: false,
        document: null,
        error: null,
        project: null,
        page_p: 1,
        title: "Importiere Anforderungsliste",
        options: {'withCredentials': true},
        pageCount: 0,
        dicectories: [],

        
    }
  },

  mounted: function() {

    
  },

  methods: {

    ulComplete(response, project) {
      
      if(response.status == "success")
      {
        this.$emit('complete', response.status);
        this.loading = false;
        this.uploaded = true;
        
      }
      else
      {
      this.$emit('failed', response.status);
        // show error toast

        this.loading = false;
        this.uploaded = false;
        this.error = true;
        this.$bvToast.toast( "Import nicht erfolgreich", {
          title: "Import",
          variant: 'danger',
          autoHideDelay: 2000,
        });

      }

      
    },


    save() {
      this.$emit('save', this.projectName);
    },

    open(project) {
      this.uploaded = false;
      this.loading = false;
      this.error = false;
      this.project = project; 
      this.inputs.fileMultiple = [];
      this.$refs.importmodal.show();
      
    }
    
    
  },

  components: {
    DropzoneFileUpload

  }
}

</script>

<style lang="scss" scoped>
    ::v-deep #onboardmodal > .modal-dialog {
        max-width: 100%;
        width: 100%;
        max-height: 100%;
    }  
</style>

